/* KLAXON: cart quantity reliability fix.
   Runs after the bundled Lumia cart script and bypasses its fragile section refresh.
   Shopify's cart/change.js is authoritative. Cart reload occurs only on success. */
(function () {
  'use strict';
  if (window.klaxonCartQuantityFixLoaded) return;
  window.klaxonCartQuantityFixLoaded = true;

  function activate() {
    const CartItems = window.customElements && customElements.get('cart-items');
    if (!CartItems || !CartItems.prototype || CartItems.prototype.klaxonQuantityFixApplied) return;
    const originalUpdate = CartItems.prototype.updateQuantity;
    if (typeof originalUpdate !== 'function') return;

    CartItems.prototype.klaxonQuantityFixApplied = true;
    CartItems.prototype.updateQuantity = async function(line, quantity, name) {
      const cartContainer = this;
      const index = Number(line);
      const count = Number(quantity);
      if (!Number.isInteger(index) || index < 1 || !Number.isInteger(count) || count < 0) {
        return originalUpdate.call(this, line, quantity, name);
      }
      if (cartContainer.dataset.klaxonQuantityBusy === 'true') return;
      cartContainer.dataset.klaxonQuantityBusy = 'true';
      cartContainer.setAttribute('aria-busy', 'true');
      const errorArea = document.getElementById('cart-errors');
      if (errorArea) errorArea.textContent = '';

      try {
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const url = root + 'cart/change.js';
        const response = await fetch(url, {
          method: 'POST',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({line: index, quantity: count})
        });
        const payload = await response.json();
        if (!response.ok || payload.errors || payload.status >= 400) {
          throw new Error(payload.description || payload.message || (typeof payload.errors === 'string' ? payload.errors : 'Could not update the cart.'));
        }
        // A clean server-rendered cart avoids errors from stale third-party
        // cart drawers, missing section HTML, and optional mini-cart elements.
        window.location.reload();
      } catch (error) {
        console.error('KLAXON cart quantity update failed:', error);
        cartContainer.dataset.klaxonQuantityBusy = 'false';
        cartContainer.removeAttribute('aria-busy');
        const message = error && error.message ? error.message : 'Cart update failed. Please try again.';
        if (errorArea) {
          errorArea.textContent = message;
          errorArea.setAttribute('role', 'alert');
        }
      }
    };
    window.klaxonCartQuantityFixActive = true;
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('cart-items').then(activate);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', activate, {once: true});
  } else {
    activate();
  }
})();
